export class InviteInfo {
    sentBy: string;
    sentDate: any;
    status: string;
}
